module.exports = __webpack_public_path__ + "static/2017_WSC_Group_2017_Individual_Income_Tax_Return_Checklist-f4042054586db4f73cfb9cab9ccf7e42.pdf";